
<modal
  title="Apply promo code"
  :open="open"
  @close="$emit('close')"
>
  <form @submit.prevent="submit">
    <text-input
      id="promo"
      v-model.trim="promoInput"
      type="text"
      label="Promo code"
    />

    <btn type="submit">
      Apply
    </btn>
  </form>
</modal>
